import { render } from "./EcoAbdominal.vue?vue&type=template&id=7692f8cf&scoped=true"
import script from "./EcoAbdominal.vue?vue&type=script&lang=js"
export * from "./EcoAbdominal.vue?vue&type=script&lang=js"

import "./EcoAbdominal.vue?vue&type=style&index=0&id=7692f8cf&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7692f8cf"]])

export default __exports__